"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("../constants");

var _componentButton = require("@doordash/component-button");

var _styles = require("../styles");

var _componentNavbar = _interopRequireDefault(require("@doordash/component-navbar"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StickyHeader = function StickyHeader(_ref) {
  var closeButtonAccessibilityLabel = _ref.closeButtonAccessibilityLabel,
      modalBackgroundColor = _ref.modalBackgroundColor,
      modalBorderRadius = _ref.modalBorderRadius,
      closeButtonSide = _ref.closeButtonSide,
      modalPadding = _ref.modalPadding,
      onClose = _ref.onClose,
      hasCloseButton = _ref.hasCloseButton,
      headerAlignment = _ref.headerAlignment,
      isFullScreenOnMobile = _ref.isFullScreenOnMobile,
      title = _ref.title,
      useDynamicPadding = _ref.useDynamicPadding,
      useHairlineDividers = _ref.useHairlineDividers;
  var navbarProps = {};

  if (hasCloseButton) {
    if (closeButtonSide === _constants.CloseButtonSides.Trailing) {
      navbarProps.navigationType = _componentNavbar["default"].NavigationTypes.None;
      navbarProps.actions = [{
        accessibilityLabel: closeButtonAccessibilityLabel,
        iconType: _componentButton.IconButton.IconTypes.Close,
        onClick: onClose
      }];
    } else {
      navbarProps.onNavigationClick = onClose;
      navbarProps.navigationType = _componentNavbar["default"].NavigationTypes.Close;
      navbarProps.strings = {
        navigationButtonLabel: closeButtonAccessibilityLabel
      };
    }
  } else {
    navbarProps.navigationType = _componentNavbar["default"].NavigationTypes.None;
  }

  return /*#__PURE__*/_react["default"].createElement(_styles.ModalStickyHeader, {
    "aria-live": "polite",
    isFullScreenOnMobile: isFullScreenOnMobile,
    modalBackgroundColor: modalBackgroundColor,
    modalBorderRadius: modalBorderRadius,
    modalPadding: modalPadding,
    showDivider: true,
    useHairlineDividers: useHairlineDividers
  }, /*#__PURE__*/_react["default"].createElement(_componentNavbar["default"], _extends({
    isSeparatorVisible: false,
    textAlign: headerAlignment,
    title: title,
    titleSize: _componentNavbar["default"].TitleSizes.Small,
    useDynamicPadding: useDynamicPadding
  }, navbarProps)));
};

StickyHeader.propTypes = {
  closeButtonAccessibilityLabel: _propTypes["default"].string,
  isFullScreenOnMobile: _propTypes["default"].bool,
  modalBackgroundColor: _propTypes["default"].string,
  modalBorderRadius: _propTypes["default"].number,
  closeButtonSide: _propTypes["default"].string,
  modalPadding: _propTypes["default"].number,
  onClose: _propTypes["default"].func,
  hasCloseButton: _propTypes["default"].bool,
  headerAlignment: _propTypes["default"].string,
  title: _propTypes["default"].string,
  useDynamicPadding: _propTypes["default"].bool,
  useHairlineDividers: _propTypes["default"].bool
};
var _default = StickyHeader;
exports["default"] = _default;